import { render } from "./Footer.vue?vue&type=template&id=d3981994&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=d3981994&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3981994"],['__file',"src/scripts/view/publicPages/components/Footer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d3981994"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d3981994', __exports__)) {
    api.reload('d3981994', __exports__)
  }
  
  module.hot.accept("./Footer.vue?vue&type=template&id=d3981994&scoped=true", () => {
    api.rerender('d3981994', render)
  })

}


export default __exports__